// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"1bb88677","977":"0fe95b16"}[chunkId] + ".chunk.js";
};